import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/connected-products')({
  beforeLoad: () => getTitleContextSlice('Connected Products'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
